export const title = 'Sales (Chart)';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

Chart of the number of sales attributed to campaigns over time.

<CampaignAttributionDateNote />
